import React from 'react'
import SupplyOrdersFilterQuery from './fields/SupplyOrdersFilterQuery'
import SupplyOrdersFilterStatus from './fields/SupplyOrdersFilterStatus'
import SupplyOrdersFilterDepartment from './fields/SupplyOrdersFilterDepartment'
import SupplyOrdersFilterAgreeDirector from './fields/SupplyOrdersFilterAgreeDirector'

const SupplyOrdersFilters = () => {
  return (
    <div className='myBlock__filtersOptions'>
        <SupplyOrdersFilterQuery />
        <SupplyOrdersFilterStatus />
        <SupplyOrdersFilterDepartment />
        <SupplyOrdersFilterAgreeDirector />
    </div>
  )
}

export default SupplyOrdersFilters